import { DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EnterNavigation } from 'src/app/orders/order/order.component';
import { DashboardService } from 'src/app/services/dashboard.service';

export class ConsultantRanking {
  constructor(
    public consultantInitials: string,
    public realizedRevenue: number,
    public budget: number,
    public months: number,
  ) {

  }
}

export class ConsultantContribution {
  constructor(
    public consultantInitials: string,
    public sales: number,
    public salary: number | null,
    public bonus: number | null,
    public sharedExpenses: number | null,
    public contribution: number,
  ) {

  }
}

@Component({
    selector: 'app-consultant-ranking',
    imports: [
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        DecimalPipe,
        EnterNavigation
    ],
    templateUrl: './consultant-ranking.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './consultant-ranking.component.scss'
})
export class ConsultantRankingComponent implements OnInit, OnChanges {
  @Input() public year: Date;
  @Input() public ranking: "highest" | "lowest";
  @Input() public includePipeline: boolean = false;
  @Input() public departmentId: string | null = null;
  public showCount: number = 10;
  private orderBacklogEksl: ConsultantRanking[] = [];
  private orderBacklogInkl: ConsultantRanking[] = [];
  private totalRevenueEksl: ConsultantRanking[] = [];
  private totalRevenueInkl: ConsultantRanking[] = [];
  private totalRevenueAfterExpensesEksl: ConsultantContribution[] = [];
  private totalRevenueAfterExpensesInkl: ConsultantContribution[] = [];

  public textColor: string;

  constructor(
    private dashboardService: DashboardService
  ) {

  }

  public get orderBacklog(): ConsultantRanking[] {
    return this.includePipeline ? this.orderBacklogInkl : this.orderBacklogEksl;
  }

  public get totalRevenue(): ConsultantRanking[] {
    return this.includePipeline ? this.totalRevenueInkl : this.totalRevenueEksl;
  }

  public get totalRevenueAfterExpenses(): ConsultantContribution[] {
    return this.includePipeline ? this.totalRevenueAfterExpensesInkl : this.totalRevenueAfterExpensesEksl;
  }

  async ngOnInit(): Promise<void> {
    const year = this.year.getFullYear();
    [
      this.orderBacklogEksl,
      this.orderBacklogInkl,
      this.totalRevenueEksl,
      this.totalRevenueInkl,
      this.totalRevenueAfterExpensesEksl,
      this.totalRevenueAfterExpensesInkl,
    ] = await Promise.all([
      this.dashboardService.consultantRanking(year, this.ranking, this.showCount, false, this.departmentId),
      this.dashboardService.consultantRanking(year, this.ranking, this.showCount, true, this.departmentId),
      this.dashboardService.consultantRankingTotal(year, this.ranking, this.showCount, false, this.departmentId),
      this.dashboardService.consultantRankingTotal(year, this.ranking, this.showCount, true, this.departmentId),
      this.dashboardService.consultantRankingAfterExpenses(year, this.ranking, this.showCount, false, this.departmentId),
      this.dashboardService.consultantRankingAfterExpenses(year, this.ranking, this.showCount, true, this.departmentId),
    ]);

    if (this.ranking === "highest") {
      this.textColor = "#388E3C";
    } else {
      this.textColor = "#F44336";
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const yearChanged = changes['year'] && changes['year'].currentValue && !changes['year'].firstChange;
    const departmentChanged = changes['departmentId'] && !changes['departmentId'].firstChange;
    if (yearChanged || departmentChanged) {
      this.ngOnInit();
    }
  }
}
